import {
  Modal,
  ModalTabs,
  PDFRenderer,
  Show,
  TreatyAuditView,
} from "components";

import { LocationGenerics } from "router/location";
import _ from "lodash";
import config from "config";
import { filterListByCurrentDomain } from "utils";
import { useSearch } from "react-location";
import { useState } from "react";
import { useTreatyAuditTrail } from "hooks/data/use-treaties";

const tabs = [
  {
    name: "Placing Slip",
    href: "PLACING_SLIP",
    domain: ["KEK", "Visal"],
  },
  {
    name: "Cover Note",
    href: "COVER_NOTE",
    domain: ["KEK", "Visal"],
  },
  {
    name: "Treaty History",
    href: "TREATY_HISTORY",
    domain: ["Visal", "KEK"],
  },
];

export default function ViewDocumentsContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [orderStatus, setOrderStatus] = useState("COVER_NOTE");
  const offer_id = searchParams?.id;
  const { treatyHistory, loading: loadingHistory } = useTreatyAuditTrail({
    input: { treatyId: offer_id || "" },
  });

  const urls = {
    COVER_NOTE: `${config.asset.uri}treaty_placing_cover_note/${btoa(
      JSON.stringify({
        treaty_id: offer_id,
        doc_type: "cover",
      })
    )}`,
    PLACING_SLIP: `${config.asset.uri}treaty_placing_cover_note/${btoa(
      JSON.stringify({
        treaty_id: offer_id,
        doc_type: "placing_slip",
      })
    )}`,
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loadingHistory}
      hideActions
      size="6xl"
      title="Documents & History"
      description="Details of documents & history are shown below"
    >
      <ModalTabs
        tabs={[...filterListByCurrentDomain(tabs)]}
        setOrderStatus={setOrderStatus}
        orderStatus={orderStatus}
      />
      <div className="p-3">
        <Show if={orderStatus !== "TREATY_HISTORY"}>
          <PDFRenderer url={_.get(urls, orderStatus)} />
        </Show>
        <Show if={orderStatus === "TREATY_HISTORY"}>
          <div className="px-11">
            <TreatyAuditView history={treatyHistory} />
          </div>
        </Show>
      </div>
    </Modal>
  );
}
